/**
 * CP-237: Hot Deals page request and Price Drops section wording.
 *
 * The hot-deals endpoint does not read a time window, so the page sends no
 * lookback_hours and shows no Time Window control (no no-op controls).
 *
 * CP-95 skips Home's price-drop highlights on Hot only while other honest
 * drops remain. When the API reports price_drops_overlap_home, the section
 * holds the same sailings as Home, so it must not be titled "More".
 *
 * Keep in sync with get_hot_deals / price_drops_overlap_home_window in
 * backend/app/routes.py and HOT_DEALS_PAGE_URL in backend/app/cache_prewarm.py.
 */
export const HOME_HIGHLIGHT_LIMIT = 10;

export function hotDealsRequestParams(toggles, filters) {
  const t = toggles || {};
  return {
    include_price_drops: Boolean(t.includePriceDrops),
    include_best_value: Boolean(t.includeBestValue),
    include_newly_listed: Boolean(t.includeNewlyListed),
    // CP-95: differentiate Hot membership from Home shelves.
    exclude_home_highlights: true,
    home_highlight_limit: HOME_HIGHLIGHT_LIMIT,
    ...(filters || {})
  };
}

export function priceDropSectionTitle(differentiatedFromHome, overlapsHome) {
  if (differentiatedFromHome && !overlapsHome) return 'More Price Drops';
  return 'Biggest Price Drops';
}

export function priceDropOverlapNote(overlapsHome, shownCount) {
  if (!overlapsHome || !(shownCount > 0)) return '';
  return 'These are the same sailings as Home’s Biggest Price Drops. There are no other price drops right now.';
}
